import types from './action-types';

export const initialState = {
  openings: [],
  stateCodes: [],
  countryCodes: [],
  positions: [],
  locationGroups: [],
  pagination: {
    currentPage: null,
    nextPage: null,
    perPage: null,
    totalCount: null,
    totalPages: null,
  },
  ui: {
    isLoading: false,
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case types.LOAD_OPENINGS:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: true,
        },
      };

    case types.LOAD_OPENINGS_RESULT: {
      const result = action.error ? {} : action.payload;
      return {
        ...state,
        ...result,
        ui: {
          ...state.ui,
          isLoading: false,
        },
      };
    }

    default:
      return state;
  }
}

const stateKey = 'openingsDirectoryDsp';

export const getComponentState = state => state[stateKey];

export default { [stateKey]: reducer };
